import React from "react";
import { Modal } from "reactstrap";
import { useTranslation } from "react-i18next";
import "./onboarding/style.scss";

/**
 * Shown after Shopify billing approval when the installer redirects to the CMS
 * with ?billingSuccess=1
 */
const ModalTrialStarted = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      backdrop="static"
      keyboard={false}
      className="modal-dialog-centered transitionSelector preview modalOnboardingWizard isOpen onboarding-trial-started"
    >
      <section>
        <div className="modal__container">
          <div className="onboarding-body">
            <div className="onboarding-step">
              <h2 className="onboarding-step__title">
                {t("homeModalWelcome.trialStarted.title")}
              </h2>
              <div className="onboarding-trial-started__stack">
                <p className="onboarding-trial-started__paragraph">
                  <strong>{t("homeModalWelcome.trialStarted.lead")}</strong>{" "}
                  {t("homeModalWelcome.trialStarted.body")}
                </p>
                <p className="onboarding-trial-started__paragraph onboarding-trial-started__contact">
                  {t("homeModalWelcome.trialStarted.contact")}
                </p>
                <p className="onboarding-trial-started__paragraph onboarding-trial-started__signoff">
                  {t("homeModalWelcome.trialStarted.signoff")}
                </p>
              </div>
            </div>
          </div>
          <div className="onboarding-footer onboarding-footer--trial-only">
            <div className="onboarding-footer__right">
              <button
                type="button"
                className="close__button modal-button save-button"
                onClick={onClose}
              >
                {t("homeModalWelcome.trialStarted.cta")}
              </button>
            </div>
          </div>
        </div>
      </section>
    </Modal>
  );
};

export default ModalTrialStarted;
